const TARGET_ID_PREFIX = 'qualifio_insert_place_';

/**
 * This function extracts the parameters from the Qualifio widget code string.
 * It looks for the _qual_async.push() method and retrieves the array of parameters.
 * @param {string} data - The Qualifio widget code string.
 * @returns {string[]} - An array of parameters extracted from the string.
 */
const getPushParamsFromString = (data: string): string[][] => {
  const matches = [...data.matchAll(/_qual_async\.push\(\s*(\[[\s\S]*?\])\s*\);/g)];
  return matches.map((match) => {
    try {
      return JSON.parse(match[1].replace(/'/g, '"'));
    } catch (e) {
      console.error('Qualifio JSON parse error:', e);
      return [];
    }
  });
};

/**
 * This function retrieves the target ID from the array of Qualifio parameters.
 * It looks for an item that starts with the TARGET_ID_PREFIX.
 * @param {string[]} data - An array of parameters.
 * @returns {string | null} - The target ID if found, otherwise null.
 */
const getTargetId = (arrays: any[][]): string | null => {
  for (const arr of arrays) {
    if (Array.isArray(arr) && typeof arr[1] === 'string' && arr[1].startsWith(TARGET_ID_PREFIX)) {
      return arr[1];
    }
  }
  return null;
};

export const QualifioService = {
  getPushParamsFromString,
  getTargetId,
};
